import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles39 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial39/tutorial39.zip?ref_type=heads&inline=false', download: 'tutorial39.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtyNine= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Create a Kanban Board in PyQt6 and Qt Designer</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/T6KDWglhFFU/maxresdefault.jpg"
                            alt="Tutorial 39"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
  In this PyQt6 tutorial, you'll learn how to create a simple Kanban-style task manager using Qt Designer and Python 3. This step-by-step guide will walk you through designing the interface, connecting form inputs, and managing task categories such as "To Do", "In Progress", and "Done".

  <br /><br /><strong>What You'll Learn:</strong>
  <ul>
    <li>How to set up PyQt6 and Qt Designer for GUI development</li>
    <li>Designing a user-friendly Kanban layout using Qt Designer</li>
    <li>Connecting form inputs to dynamically add tasks</li>
    <li>Organizing tasks into Kanban columns (To Do, In Progress, Done)</li>
  </ul>

  By the end of this tutorial, you’ll have a functional and lightweight Kanban application built with PyQt6 — perfect for beginners or anyone looking to understand the basics of GUI form handling and task organization.

  <br /><br />
  #PyQt6 #QtDesigner #Python3 #KanbanApp #TaskManager #SimpleProjects #PythonGUI #ProductivityTool
</p>


                    <button className="seemore">
                        <DownloadFiles39 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtyNine;
